import Book from 'models/book'
import ChapterListItem from 'models/chapter-list-item'

import Link from 'next/link'
import routes from 'routes'

const ChapterBlockList = ({
  chapters,
  book,
}: {
  chapters: ChapterListItem[]
  book: Book
}): JSX.Element => {
  return (
    <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {chapters.map((chapter) => {
        return (
          <li key={chapter.id} className="rounded-lg bg-gray-100">
            <Link
              href={routes.story.chapter({
                bookId: book.id,
                bookTitle: book.title,
                chapterOrdinal: chapter.order,
              })}
              title={chapter.title}
              className="flex h-12 px-4 items-center"
            >
              <h3 className="text-base truncate text-[#15141F] font-medium">
                #{chapter.order} {chapter.title}
              </h3>
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default ChapterBlockList
